import { useEffect } from 'react';

interface PageMeta {
  title: string;
  description: string;
  path: string;
}

const BASE_URL = 'https://progeodata.com';

const defaults: PageMeta = {
  title: 'ProGeoData',
  description: 'The definitive API for verifying licensed professionals.',
  path: '/',
};

export function usePageMeta(meta: Partial<PageMeta>) {
  useEffect(() => {
    const title = meta.title ? `${meta.title} | ProGeoData` : defaults.title;
    const description = meta.description || defaults.description;
    const url = `${BASE_URL}${meta.path || defaults.path}`;

    document.title = title;

    const setMeta = (selector: string, attr: string, value: string) => {
      const el = document.querySelector(selector);
      if (el) el.setAttribute(attr, value);
    };

    setMeta('meta[name="description"]', 'content', description);
    setMeta('meta[property="og:title"]', 'content', title);
    setMeta('meta[property="og:description"]', 'content', description);
    setMeta('meta[property="og:url"]', 'content', url);
    setMeta('meta[property="twitter:title"]', 'content', title);
    setMeta('meta[property="twitter:description"]', 'content', description);
    setMeta('meta[property="twitter:url"]', 'content', url);
    setMeta('link[rel="canonical"]', 'href', url);
  }, [meta.title, meta.description, meta.path]);
}
